/* src/app/shared/bloco-animado/bloco-animado.component.scss */
.conteudo {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 10px;
  margin-bottom: 10px;
  vertical-align: middle;
  padding: 10px;
  padding-top: 15px;
  padding-bottom: 0px;
}
.bloco-interno {
  border-color: rgba(0, 0, 0, 0.125);
  border-style: solid;
  border-width: 0px 1px 1px 1px;
  border-radius: 0px 0px 10px 10px;
  margin-bottom: 10px;
  vertical-align: middle;
  padding: 10px;
  padding-top: 15px;
  margin-top: -10px;
}
.title {
  font-weight: 500;
  font-size: medium;
}
.cursor {
  float: left;
  margin-right: 15px;
}
/*# sourceMappingURL=bloco-animado.component.css.map */
